import { ValuationTypes } from '@constants/common';

import {
  DealMarkup,
  GetRoundsRes,
  Round,
  RoundType,
  Valuation
} from '../types';
import { getNumbersOnly } from '@utils/common';

export type TimeLineData = {
  type: RoundType;
  companyStage: string;
  id: string;
  convertibleTerms: string;
  roundDate: string;
  roundName: string;
  size: string | number;
  valuation: string | number;
  valuationType: string;
  investorCount: number;
  dealMarkups?: DealMarkup[];
};

const formatRounds = (rounds: Round[]) => {
  return rounds.map(item => ({
    type: RoundType.ROUND,
    companyStage: item.company_stage,
    id: item.id,
    convertibleTerms: item.convertible_Debts,
    roundDate: item.round_date,
    roundName: item.round_name,
    size: item.size,
    valuation: item.valuation,
    valuationType: item.valuation_type,
    investorCount: item.investor_count,
    dealMarkups: item.deal_markups
  }));
};

const formatValuationUpdate = (valuations: Valuation[]) => {
  return valuations.map(item => ({
    type: RoundType.VALUATION_UPDATE,
    id: item.id,
    roundDate: item.round_date,
    valuation: item.valuation,
    valuationType: ValuationTypes.PRICED,
    roundName: '',
    convertibleTerms: '',
    companyStage: '',
    size: '',
    investorCount: 0
  }));
};

const formatRoundsTimelineData = (data: GetRoundsRes) => {
  const formattedRounds = formatRounds(data.rounds ? data.rounds : []);
  const formattedValuations = formatValuationUpdate(
    data.valuations ? data.valuations : []
  );
  const mergedData = [...formattedRounds, ...formattedValuations];
  const sortedData = mergedData.sort((a, b) => {
    if (new Date(a.roundDate) > new Date(b.roundDate)) return -1;
    if (new Date(a.roundDate) < new Date(b.roundDate)) return 1;
    return 0;
  });
  return sortedData;
};

const calculateGrowth = (
  timeLineData: TimeLineData[],
  currentValuation: number
) => {
  const nearestValuation = timeLineData.find(item => !!item.valuation);
  if (nearestValuation)
    return (
      currentValuation -
      (nearestValuation.valuation
        ? parseInt(getNumbersOnly(nearestValuation.valuation as string))
        : 0)
    );
  return null;
};

export { formatRoundsTimelineData, calculateGrowth };
